import {
  Actions,
  createMapper,
  Getters,
  Module,
  Mutations
} from 'vuex-smart-module'
import { Vue } from 'vue-property-decorator'
import { AffiliationFilter } from '@/types/interfaces/affiliations'
import PublicationsAPI from '@/api/requests/publications'
import * as _ from 'lodash'

class AffiliationsState {
  affiliationsFilters: AffiliationFilter[] | null = null
}

class AffiliationsGetters extends Getters<AffiliationsState> {
  affiliationsFilters() {
    return this.state.affiliationsFilters
  }
}

export class AffiliationsMutations extends Mutations<AffiliationsState> {
  setAffiliationsFilters(filters: AffiliationFilter[] | null) {
    Vue.set(this.state, 'affiliationsFilters', filters)
  }
}

class AffiliationsActions extends Actions<
  AffiliationsState,
  AffiliationsGetters,
  AffiliationsMutations,
  AffiliationsActions
> {
  async fetchAffiliations() {
    if (_.isEmpty(this.state.affiliationsFilters)) {
      const response = await PublicationsAPI.getAffiliationsConfig()
      this.mutations.setAffiliationsFilters(response.data)
    }
  }

  async updateAffiliationsConfig(data: AffiliationFilter[]) {
    await PublicationsAPI.updateAffiliationsConfig(data)
    this.mutations.setAffiliationsFilters(data)
  }
}

export const affiliations = new Module({
  state: AffiliationsState,
  getters: AffiliationsGetters,
  mutations: AffiliationsMutations,
  actions: AffiliationsActions
})

export const affiliationsMapper = createMapper(affiliations)
